import { useCallback } from 'react';
import { useAuth } from '@frontegg/react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { AI_QUOTA } from '../constants/queryKeys';
import { fetchAiQuota } from '../services/api';
import { isInSaaSMode } from '../utils/common';

const useAiQuota = (enabled: boolean = true) => {
  const authHook = isInSaaSMode() ? useAuth : null;
  const { isAuthenticated } = authHook?.() || {};
  const queryClient = useQueryClient();
  const { data, isLoading, isFetched, isError } = useQuery(
    [AI_QUOTA],
    fetchAiQuota,
    {
      enabled: enabled && isAuthenticated,
    },
  );

  const invalidateQuotaQuery = useCallback(
    () => queryClient.invalidateQueries([AI_QUOTA]),
    [queryClient],
  );

  return {
    data,
    isLoading,
    isFetched,
    isError,
    invalidateQuotaQuery,
  };
};

export default useAiQuota;
